






































import { defineComponent } from '@nuxtjs/composition-api';
import { SfIcon } from '@storefront-ui/vue';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'Teaser',
  components: {
    SfIcon,
  },
  props: {
    imagePath: { type: String, default: '' },
    caption: { type: String, default: '' },
    headline: { type: String, default: '' },
    url: { type: String, default: '' },
    numberOfItems: { type: Number, default: 1 },
  },
  setup(props) {
    const backgroundImage: string = addBasePath(props.imagePath);
    return {
      backgroundImage,
    };
  },
});
